'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Storage = require('../util/Storage');

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QA_DOT_COM = 'qa.com';

var storage = void 0;
try {
  var localStorage = window && window.localStorage ? window.localStorage : false;
  storage = new _Storage2.default(localStorage);
} catch (e) {
  storage = new _Storage2.default(false);
}

var env = {
  isQa: function isQa() {
    if (storage.getItem('ENV') === 'qa') {
      return true;
    }
    return document.domain.indexOf(QA_DOT_COM) >= 0;
  }
};

exports.default = env;
module.exports = exports['default'];